import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Mail, Send } from "lucide-react";
import { toast } from "sonner";

export default function EmailSubscribe() {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [configured, setConfigured] = useState(true);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!open) return;
    api.get("/subscription").then((r) => {
      setEmail(r.data.email || "");
      setConfigured(r.data.resend_configured);
    });
  }, [open]);

  const save = async () => {
    if (!email) return toast.error("Enter an email.");
    setBusy(true);
    try {
      await api.post("/subscription", { email });
      toast.success("Subscribed. You'll get the morning digest once Resend is enabled.");
    } catch {
      toast.error("Could not save");
    } finally { setBusy(false); }
  };

  const sendNow = async () => {
    if (!email) return toast.error("Enter an email first.");
    setBusy(true);
    try {
      await api.post("/digest/send", { email });
      toast.success(`Digest sent to ${email}.`);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Send failed");
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" className="gap-2" data-testid="email-digest-btn">
          <Mail className="w-4 h-4 text-accent" /> Email digest
        </Button>
      </DialogTrigger>
      <DialogContent className="bg-card">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl">Today, by post</DialogTitle>
          <DialogDescription>
            Get the Sage's daily counsel and open tasks delivered to your inbox.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-3">
          <Input
            type="email"
            placeholder="you@garden.email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="email-input"
          />
          {!configured && (
            <div className="text-xs text-muted-foreground bg-muted/60 p-3 rounded-md leading-relaxed">
              Add <code>RESEND_API_KEY</code> to the backend to enable sending. You can still
              subscribe now and emails will start once the key is in place.
            </div>
          )}
        </div>

        <DialogFooter className="gap-2 sm:gap-2">
          <Button variant="ghost" onClick={save} disabled={busy} data-testid="email-save">Save subscription</Button>
          <Button onClick={sendNow} disabled={busy || !configured} className="bg-primary hover:bg-primary/90 gap-1.5" data-testid="email-send-now">
            <Send className="w-4 h-4" /> Send now
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
